import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, inject } from '@angular/core';
import { GungMenu } from '../../../services/gung-main-menu/gung-main-menu.service';

@Component({
    selector: 'lib-gung-expand-menu',
    templateUrl: './gung-expand-menu.component.html',
    styleUrl: './gung-expand-menu.component.scss',
    standalone: false
})
export class GungExpandMenuComponent implements OnInit {

  private el = inject(ElementRef);

  @Input() menu!: GungMenu[];

  @Input() top!: number;

  @Input() left!: number;

  @Input() levels!: number;

  @Input() mobileDevice: boolean = false;

  // Off by default - see GungNavbarService.showMenuIcons for why this isn't just "show it whenever
  // link.icon happens to be set".
  @Input() showIcons: boolean = false;

  @Output() closeExpandMenu = new EventEmitter<boolean>();

  secondMenuLinks: GungMenu[] | null = null;

  isSecondMenuVisible = false;

  computedWidth: number | null = null;

  // Only the two-level grid layout and the hovered desktop third-level column
  // need a stretched width; a plain single-column menu should stay content-sized.
  // Kept as a plain field (recomputed only where levels/secondMenuLinks change)
  // instead of a template getter, which Angular would re-evaluate every change detection cycle.
  hasWideContent = false;

  ngOnInit(): void {
    this.hasWideContent = this.levels === 3;
    this.computeWidth();
  }

  @HostListener('window:resize')
  computeWidth(): void {
    // .sub-menu is display:none when not hovered (CSS), so getBoundingClientRect returns zeros.
    // Navigate up to .s-menu (parentElement.parentElement) which is always visible in the navbar.
    const sMenu = this.el.nativeElement?.parentElement?.parentElement;
    if (!sMenu) { return; }
    const rect = sMenu.getBoundingClientRect();
    const available = window.innerWidth - rect.left - 16;
    this.computedWidth = Math.min(available, window.innerWidth - 50);
  }

  showSecondMenu(menus: GungMenu[]): void {
    this.secondMenuLinks = menus;
    this.hasWideContent = this.levels === 3 || this.levels > 3;
  }

  menuClick(link: GungMenu){
    if(link.action){
      link.action();
    }
    this.closeExpandMenu.emit(true);
  }

  hideSecondMenu(): void {
    this.secondMenuLinks = null;
    this.hasWideContent = this.levels === 3;
  }

  preventAndStop(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
